import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Button from 'react-bootstrap/Button';
import { useContext, useEffect, useState } from "react";
import Image from 'react-bootstrap/Image';
import {
    useLocation,
    useNavigate
  } from "react-router-dom";
import Alert from 'react-bootstrap/Alert';
import $ from 'jquery'
import UserContext from '../../contexts/UserContext';

const Login = () => {
    const navigate = useNavigate();
    const props = useLocation();
    const [message, setMessage] = useState('');
    const {user,setUser} = useContext(UserContext);
    const [show, setShow] = useState(true);

    const updateData = (e) => {
        e.preventDefault();
        const form = e.target;
        const formData = {
            hof:form.hof.value,
            password:form.password.value
        }
        // axios.post(process.env.REACT_APP_API_URL+"/login", formData)
        // .then(function (response) {
        //     console.log(response);
        // })
        // .catch(function (error) {
        //     console.log(error);
        // });
        $.ajax({
            type:"POST",
            url:process.env.REACT_APP_API_URL+"/login",
            data:formData,
            xhrFields: {
                withCredentials: true  // Include cookies
              },
              crossDomain: true, 
             success : function(response){
              if(response.message && response.message.includes("Logged in")){
                console.log(response)
                try{
                localStorage.setItem('userSession',JSON.stringify(response.user._id))
                }catch(e){console.log(e)}
                setUser(response.user)
                navigate('/home')
              }else if(response.message){
                setMessage(response.message);
                e.target.hof.value='';
                e.target.password.value='';
              }else{
                navigate("/login",{state:{message:"Something went wrong !"}});
              }
              
            },
            error: function(err){
                console.log("error")
                console.log(err)
                navigate(0,{state:{message:"Something went wrong !"}})
            }
        })
    }

    useEffect(()=>{
        if(props && props.state && typeof props.state.message != "undefined"){
            setMessage(props.state.message)
            props.state={};
        }else{
            setMessage("");
        }
    },[])

    const design = (
        <>
        {message?<Alert key='danger' variant='danger' onClose={() => setShow(false)} dismissible>{message} !</Alert>:null}
        <div className="w-100 d-flex flex-column flex-wrap align-items-center"> 
            <Image src="fmb_logo.png" rounded />
            <h6 className='' style={{marginTop:"-50px", color:'#6E260E',fontFamily:'cursive',fontSize:'16px'}} >Istifaah Ilmiyah - Surat</h6>
            <Form onSubmit={updateData} className='m-2'>
                <Form.Group as={Row} className="mb-3" controlId="formPlaintextEmail">
                    <Form.Label column sm="2">
                    ITS
                    </Form.Label>
                    <Col sm="10">
                    <Form.Control type="text" name='hof' placeholder="HOF ITS" />
                    </Col>
                </Form.Group>

                <Form.Group as={Row} className="mb-3" controlId="formPlaintextPassword">
                    <Form.Label column sm="2">
                    Password
                    </Form.Label>
                    <Col sm="10">
                    <Form.Control type="password" name='password' placeholder="Password" />
                    </Col>
                </Form.Group>
                <Button as="input" type="submit" value="Submit" />
            </Form>
        </div>
        </>
        
    )
    return design;
}

export default Login;